import { useAuth } from '../../context/AuthProvider'
import { Navigate, Outlet } from "react-router-dom"
import { Toggle } from '../Toggle';
import { useTheme } from '../ThemeContext';
import { Box } from '@mui/material';
import dataService from '../../services/Data'

export default function ProtectedRoute() {
    const { user, logout, isSessionActive } = useAuth()
    const { isDarkMode, toggleDarkMode } = useTheme(); // Obtener isDarkMode y toggleDarkMode del ThemeContext

    // Si no hay usuario, redirigir a /login
    if (!user || !user.data || !user.data.token) {
        return <Navigate to="/login" replace />;
    }

    if (!isSessionActive()) {
        logout();
        return <Navigate to="/login" replace />;
    }

    return (
        <>
            <Outlet />
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 8,
                    right: 8,
                    zIndex: 1201, // Por encima de la NavBar (AppBar usa zIndex: 1200 por defecto)
                    padding: 1,
                    color: isDarkMode ? 'white' : 'black',
                }}
            >
                <Toggle isChecked={isDarkMode} handleChange={toggleDarkMode} />
            </Box>
        </>
    )
}